import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  padding: 4rem 2rem;
  color: white;
  background: #0b0b0b;
  font-family: "Poppins", sans-serif;
  min-height: 100vh;
  box-sizing: border-box;
  overflow-x: hidden;
  width: 100%;
  @media (max-width: 768px) {
    padding: 2rem 1rem;
  }
`;

const Heading = styled.h1`
  font-size: 3rem;
  color: ${({ theme }) => theme.primary};
  margin-bottom: 1rem;
`;

const Paragraph = styled.p`
  max-width: 850px;
  width: 100%;
  font-size: 1.15rem;
  line-height: 1.9;
  color: #ccc;
  word-break: break-word;
`;

const Highlight = styled.span`
  color: ${({ theme }) => theme.secondary};
  font-weight: 600;
`;

const AboutUs = () => {
  return (
    <Wrapper>
      <Heading>About Engineer Codewala</Heading>
      <Paragraph>
        <Highlight>Engineer Codewala</Highlight> is a platform designed to{" "}
        empower developers and businesses alike. Our mission is to provide
        high-quality services and resources that help you grow, learn, and
        succeed in the tech industry.
        <br />
        <br />
        Currently, we offer:
        <ul>
          <li>
            <Highlight>Freelancing Development Services</Highlight> – Get your
            projects built by experienced developers.
          </li>
          <li>
            <Highlight>Paid Courses</Highlight> – Learn real-world skills with
            structured content and hands-on projects.
          </li>
          <li>
            <Highlight>Free Interview Preparation</Highlight> – Access curated
            resources to crack technical interviews with confidence.
          </li>
        </ul>
        <br />
        At <Highlight>Engineer Codewala</Highlight>, we believe in building
        skills, solving problems, and creating opportunities for developers to
        shine.
      </Paragraph>
    </Wrapper>
  );
};

export default AboutUs;
